import { addLocale } from 'primereact/api';

export const LocaleBg =
    addLocale('bg', {
        firstDayOfWeek: 1,
        dayNames: ['Неделя', 'Понеделник', 'Вторник', 'Сряда', 'Четвъртък', 'Петък', 'Събота'],
        dayNamesShort: ['Нед', 'Пон', 'Вт', 'Ср', 'Чет', 'Пт', 'Съб'],
        dayNamesMin: ['Н', 'П', 'В', 'С', 'Ч', 'П', 'С'],
        monthNames: ['Януари', 'Февруари', 'Март', 'Април', 'Май', 'Юни', 'Юли', 'Август', 'Септември', 'Октомври', 'Ноември', 'Декември'],
        monthNamesShort: ['Яну', 'Фев', 'Март', 'Апр', 'Май', 'Юни', 'Юли', 'Авг', 'Сеп', 'Окт', 'Ное', 'Дек'],
        today: 'Днес',
        clear: 'Изчисти',
        dateFormat: 'dd-mm-yy'
    });